import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ViewChild,
  HostListener,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { NgForm } from '@angular/forms';
import * as authUtils from '../../auth-utils';
import * as authConsts from '../../auth-constants';
import { UserAccountType, UserAccountStatus } from 'src/app/shared/enum';
import { UserViewModel } from 'src/app/shared/models/user';
import { AuthIntegrationService } from 'src/app/shared/services/authentication/auth-integration.service';
import {
  CognitoResponseCode,
  AppConstants,
  countryOption
} from 'src/app/shared/utilities/constants';
import { ToastService } from 'src/app/shared/services/common/toast.service';
import { options } from 'src/app/shared/models/profile/trips';
import { SignupService } from '../../service/signup.service';
import { LoaderService, LogglyLoggerService } from '@laasy/common-layout';
import { SignupTenantPageCount, ssoCognitoEmailPasswordSignup } from '../../auth-constants';
import { AuthConnectService } from '../../service/auth-connect.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { LaasyModalComponent } from 'src/app/shared/components/laasy-modal/laasy-modal.component';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';

@Component({
  selector: 'app-email-signup',
  templateUrl: './email-signup.component.html',
  styleUrls: ['../../auth-connect/auth-connect.component.scss', './email-signup.component.scss']
})
export class EmailSignupComponent implements OnInit,OnDestroy {
  @Input() SSObutton: any;
  @Input() SSO_val: any;
  @Input() userProfile: any;
  @Output() routing = new EventEmitter<string>();
  @Output() pass_check = new EventEmitter<any>();
  @Output() noOfViewCount = new EventEmitter<number>();
  @ViewChild('authForm') signInForm!: NgForm;
  tenantName = 'Laasy';
  mainAttractionsData = AppConstants.gettingStartedMainAttractionContent;
  verifyOtpResendTime = AppConstants.otpTimer;
  filterOptions: options[] = countryOption;
  ssoCognitoEmailPasswordSignup = ssoCognitoEmailPasswordSignup;


  termsAndConditions!: any;
  privacyPolicy!: any;
  isPdfModalVisible: boolean = false;
  pdfSource: any;
  readOnlyEmail = false;
  screenWidth!: number;
  showMainAttractionsData: any = [];
  signupPageCount: number = 0;
  heading!: string;
  subheading1!: string;
  subheading2!: string;
  countryOptions: any = [];
  otpInputConfig = authConsts.verifyPhoneOtpConfig;
  remainingTime: number = 10;
  resendTimeout: any;
  noOfView: number = 3;
  page: string = 'signup';
  elementName: string = 'email';
  SignupTenantPageCount:any = SignupTenantPageCount
  subscriptions!:Subscription[];
  @ViewChild('laasyModal') laasyModal!: LaasyModalComponent;

  constructor(
    private toastService: ToastService,
    private readonly authService: AuthenticationService,
    private readonly authIntegrationService: AuthIntegrationService,
    private readonly signUpService: SignupService,
    private loaderService: LoaderService,
    private tenantService: TenantService,
    private authconnect:AuthConnectService,
    private cd: ChangeDetectorRef,
    private loggly: LogglyLoggerService
  ) {}

  ngOnInit(): void {
    this.setSourceURL();
    this.getTerms();
    if (this.userProfile.email) {
      this.readOnlyEmail = true;
    }
    this.checkLandingSignupPage();
    this.onWindowResize();
    this.tenantService.getTenantAppConfig().subscribe((data: any) => {
      this.tenantName = data.name ?? '';
    });
    this.signupServiceSubscriptions()
    this.signUpService.setSignUpPageCount(0)
    this.signUpService.setTriggerSubmitObservable(-1)
  }

  signupServiceSubscriptions():void{
    const signupPageSubs = this.signUpService.getSignUpPageCountObservable().subscribe((count:number)=>{
      this.signupPageCount = count
      this.updateHeadings()
      if(count===0){
        this.checkLandingSignupPage()
      }
      this.cd.detectChanges()
    })
    const signupSubmitSubs =this.signUpService.getTriggerSubmitObservable().subscribe((signupType:number)=>{
      if(signupType===authConsts.signupSubmitType.email) this.SignupAWS()
      else if(signupType===authConsts.signupSubmitType.verify_email) this.verifyEmail()
    })
    const customizationApplied = this.authconnect.customizationApplied$.asObservable().subscribe(async _=>{
      const data = await firstValueFrom(this.authconnect.getSubtenantFromURL())
      this.authconnect.updateTenantCustomizationCSS(data.subTenant)
    })
    // caching
    this.signUpService.getOTPTimer().subscribe(_=>{})
    this.subscriptions=[signupPageSubs,signupSubmitSubs,customizationApplied]
  }

  setSourceURL(){
    const signupSourceURL = location.href
    if(signupSourceURL?.toLowerCase()?.includes("utm_"))   localStorage.setItem("signupSourceURL",signupSourceURL)
  }

  navigate(url: string) {
    this.routing.emit(url);
    this.checkLandingSignupPage();
  }

  checkLandingSignupPage() {
    this.SignupTenantPageCount = this.signUpService.getSignupEnum()
    this.noOfView = this.signUpService.getProgressBarCount()
    this.noOfViewCount.emit(this.noOfView);
  }

  updateHeadings() {
    const data = this.authconnect.setHeadings(this.signupPageCount)
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.screenWidth = window.innerWidth;
    this.showMainAttractionsData = this.mainAttractionsData;
  }


  getStarted() {
   if(this.termsAndConditions && this.privacyPolicy){
    this.checkLandingSignupPage();
    this.signUpService.onContinue(this.userProfile)
   }
   else{
    this.openToastmsg({
      ...authConsts.warning_msg,
      heading: 'Something went wrong',
      text: authUtils.ErrorMsgDict('', 'Please refresh the page and try again later.')
    });
    this.getTerms()
   }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async SignupAWS() {
    const response = await this.authService.SignUp({
      firstName: this.userProfile.fname,
      lastName: this.userProfile.lname,
      email: this.userProfile.email,
      password: this.userProfile.pass,
      phoneNumber: this.userProfile.phone.replace(/-/g, '')
    });
    if (response?.user) this.SignupPre(response);
    else if (response?.code === CognitoResponseCode.UsernameExistsException)
      this.openToastmsg({
        ...authConsts.warning_msg,
        heading: 'Account Exists',
        text: authUtils.ErrorMsgDict('', 'Account Exists')
      });
    else if (response?.code === CognitoResponseCode.CodeDeliveryFailureException)
      this.openToastmsg({
        ...authConsts.warning_msg,
        heading: 'Error',
        text: authUtils.ErrorMsgDict('', 'invalidcode')
      });
    else if (response?.code === CognitoResponseCode.InvalidPasswordException)
      this.openToastmsg({
        ...authConsts.warning_msg,
        heading: 'Error',
        text: authUtils.ErrorMsgDict('', 'Invalid Credentials')
      });
    else if(response?.code === "UserLambdaValidationException" && response?.message?.includes("PreSignUp failed with error User already exists")){
      // prompt user for next steps
      const providerName = response?.message?.split('#Provider:')[1]?.replace('.','')
      this.ssoCognitoEmailPasswordSignup.providerName = providerName;
      this.ssoCognitoEmailPasswordSignup.description = this.ssoCognitoEmailPasswordSignup.description.replaceAll('{{SSO Provider}}', providerName);
      const errorMessage = authUtils.ErrorMsgDict('', 'SSO email password signup')?.replaceAll('{{SSO Provider}}', providerName);

      this.openToastmsg({
        ...authConsts.warning_msg,
        heading: 'Error',
        text: errorMessage
      });
      this.ssoCognitoEmailPasswordSignup.showModal = true;
      setTimeout(()=>this.laasyModal?.openModal(),100)
    }
    else{
      console.error(JSON.stringify(response));
      this.openToastmsg({
        ...authConsts.warning_msg,
        heading: 'Something went wrong',
        text: authUtils.ErrorMsgDict('', '')
      });
    }
  }

  SSORedirectWithUserData() {
    sessionStorage.setItem('ssoSignupUserInfo', JSON.stringify(this.userProfile));
    this.ssoCognitoEmailPasswordSignup.showModal = false;
    this.authService.FederatedAuth(this.ssoCognitoEmailPasswordSignup.providerName);
  }

  //signup
  async getTerms(): Promise<void> {
    const response = await this.signUpService.getTerms();
    this.termsAndConditions = response.termsAndConditions;
    this.privacyPolicy = response.privacyPolicy;
  }

  async verifyEmail() {
    if (!(await this.authconnect.checkEmail('signup',this.userProfile.email))) return;
    else   this.signUpService.onContinue(this.userProfile,true);
  }

  async SignupPre(response: any) {
    this.loaderService.show()
    const signupSourceURL = localStorage.getItem("signupSourceURL")||''
    let userRequest: UserViewModel = {
      userId: response?.userSub,
      firstName: this.userProfile.fname,
      lastName: this.userProfile.lname,
      email: this.userProfile.email,
      displayName: `${this.userProfile.fname} ${this.userProfile.lname}`,
      accountType: UserAccountType.Cognito,
      termsAgreementId: this.termsAndConditions.agreementId,
      policyAgreementId: this.privacyPolicy.agreementId,
      timeStamp: new Date(),
      phoneNumber: this.userProfile.phone.replace(/-/g, ''),
      OptInEmailSubscription: this.userProfile.email_opt_in,
      OptInSmsSubscription: this.userProfile.sms_opt_in,
      country: this.userProfile.country,
      zipCode: this.userProfile.zipCode,
      sourceUrl:signupSourceURL,
      survey:this.userProfile?.survey,
      ageRange: this.userProfile?.ageRange,
      gender: this.userProfile?.gender
    };

    if(this.signUpService.isSubTenant())
      userRequest = {...userRequest,subTenantId:this.userProfile.subtenant}
    if(this.signUpService.isAuthCodeEnabled())
      userRequest = {...userRequest,authCode:this.userProfile.authCode}
    this.authIntegrationService.addSignupUser(userRequest).subscribe(
      async res => {
        this.loaderService.hide()
        if (res?.isSuccess) {
          const signUpResponse = res.data;
          if (signUpResponse.signUpSuccess) {
            this.signInForm?.reset();
            localStorage.setItem('onboardingFlag',String(true))
            localStorage.removeItem("signupSourceURL")
            authUtils.clearStoredSignupCode()
            await this.authconnect.userSignIn(this.userProfile.email,this.userProfile.pass)
          } else if (signUpResponse.userExist) {
            if (signUpResponse.accountStatus == UserAccountStatus.Deleted)
              this.openToastmsg({
                ...authConsts.error_msg,
                heading: 'Account Cancelled',
                text: authUtils.ErrorMsgDict(this.userProfile.email, 'Account Cancelled')
              });
            else if (signUpResponse.accountStatus == UserAccountStatus.Active)
              this.openToastmsg({
                ...authConsts.warning_msg,
                heading: 'Account Exists',
                text: authUtils.ErrorMsgDict(this.userProfile.email, 'Account Exists')
              });
          } else if (!signUpResponse.userExist && !signUpResponse.isEligible)
            this.openToastmsg({
              ...authConsts.warning_msg,
              heading: 'Email address not found',
              text: authUtils.ErrorMsgDict(this.userProfile.email, 'Email address not found')
            });
        } else{
          console.error(JSON.stringify(res));
          this.openToastmsg({
            ...authConsts.error_msg,
            heading: 'Something went wrong',
            text: authUtils.ErrorMsgDict('', 'Something went wrong signup')
          });
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      error => {
        this.loggly.ErrorLog(error as Error);
        this.openToastmsg({
          ...authConsts.error_msg,
          heading: 'Something went wrong',
          text: authUtils.ErrorMsgDict('', 'Something went wrong signup')
        });
      }
    );
  }

  openToastmsg(msg: any) {
    this.toastService.setToast({...msg });
  }

  isForm(){
    // hide progressbar
    if(this.signUpService.showSurvey() && this.signupPageCount === this.SignupTenantPageCount?.survey) return false
   if(this.SignupTenantPageCount?.subtenant)
    return this.signupPageCount > this.SignupTenantPageCount?.subtenant
   return this.signupPageCount > this.SignupTenantPageCount?.getting_started
  }

  selectedSubtenant(subtenantId: string): void {
    this.userProfile.subtenant = subtenantId;
    this.signUpService.onContinue(this.userProfile);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x:any)=>x?.unsubscribe())
  }
}
